import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"
import {StyledSlider} from "../../../components"

export const StandardStyledSlider = styled(StyledSlider)`
    width: 100%;
    @media (min-width: ${breakpoints.values.lg}px) {
        width: 80%;
    }
`

export default StandardStyledSlider
